import { render, staticRenderFns } from "./VExpenseForm.vue?vue&type=template&id=61d4e348&"
import script from "./VExpenseForm.vue?vue&type=script&lang=js&"
export * from "./VExpenseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports